import { createContext, useContext } from "react";

const ServicesContext = createContext(null);

export const useService = () => {
  return useContext(ServicesContext);
};

export default ServicesContext;
